import { Injectable } from '@angular/core';
import { WeappsServices } from '../api/weapps';
import type { paths as VEGA_PATHS } from '../api/weapps/vega'
import type { paths as ALTAIR_PATHS } from '../api/weapps/altair2'

export type Entitlements = VEGA_PATHS["/entitlements"]["get"]["responses"][200]["content"]['application/json'];
export type ProductStruct = ALTAIR_PATHS["/product/{productId}"]["get"]["responses"][200]["content"]['application/json'];
export type ContentData = ALTAIR_PATHS["/content/{contentId}"]["get"]["responses"][200]["content"]['application/json'];

@Injectable({
  providedIn: 'root'
})
export class NewProductService {

  async getEntitlements(): Promise<Entitlements>{
    const api = await WeappsServices.vega();
    const response = await api.GET('/entitlements');

    if(response.response.status !== 200 || !response.data) {
      throw new Error(`Failed to data: ${response.response.statusText}`);
    }else{
      return response.data;
    }
  }

  async getProductStruct(productId:string): Promise<ProductStruct> {
    const api = await WeappsServices.altair();
    const response = await api.GET("/product/{productId}", {
      params: {
        path: { productId: productId }
      }
    });

    if(response.response.status !== 200 || !response.data) {
      throw new Error(`Failed to get data: ${response.response.statusText}`);
    }else{
      let struct = response.data;
      struct = struct.map(module => ({
        ...module,
        contents: module.contents.sort((a, b) => a.displayOrder - b.displayOrder)
      }));
      // Sort modules by displayOrder
      struct = struct.sort((a, b) => a.displayOrder - b.displayOrder);
      return struct;
    }
  }

  async getContent(contentId:string): Promise<ContentData> {
    const api = await WeappsServices.altair();
    const response = await api.GET("/content/{contentId}", {
      params: {
        path: { contentId: contentId }
      }
    });

    if(response.response.status !== 200 || !response.data) {
      throw new Error(`Failed to get data: ${response.response.statusText}`);
    }else{
      return response.data;
    }
  }

}